import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { User } from '../../models/user.model';
import { UserRoleEnum } from '../../enums/user-role-enum';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'menu-items',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './menu-items.component.html',
  styleUrl: './menu-items.component.css',
})
export class MenuItemsComponent implements OnInit {
  loggedUser: User = new User();
  userValidation = false;
  constructor(private authService: AuthService) {}
  ngOnInit(): void {
    this.loggedUser = this.authService.CurrentUserValue;
    if (this.loggedUser.role === UserRoleEnum.User) {
      this.userValidation = true;
    }
  }
}
